export class SarsConfig {
  public sda: number;
  public fia: number;
}
